// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from "react";
import {
  Box,
  Container,
  Flex,
  FlexProps,
  forwardRef,
  useStyleConfig,
} from "@chakra-ui/react";

import { useScrollbarInfo } from "../../hooks";

export interface AppBarProps extends FlexProps {
  color?: string;
}

export const AppBar = forwardRef<AppBarProps, "div">(
  ({ position = "fixed", sx, color = "primary", children, ...rest }, ref) => {
    const styles = useStyleConfig("AppBar");
    const { hasYScrollbar, yScrollbarWidth } = useScrollbarInfo();

    return (
      <>
        <Flex
          position={position}
          sx={{
            width: "100%",
            zIndex: 5,
            flexShrink: 0,
            flexDirection: "column",
            top: 0,
            right: 0,
            left: "auto",
          }}
        >
          <Flex
            __css={styles}
            ref={ref}
            sx={{
              pr: hasYScrollbar ? 0 : yScrollbarWidth,
              ...sx,
            }}
            backgroundColor={color}
            {...rest}
          >
            <Container>
              <Flex
                sx={{
                  alignItems: "center",
                  flex: 1,
                  position: "relative",
                }}
              >
                {children}
              </Flex>
            </Container>
          </Flex>
        </Flex>
        <Box __css={styles} />
      </>
    );
  }
);
